import { FilterBuilder } from '@/shared/filters/filter-builder';
import { DeviceFilterInput } from '@/shared/types/types.generated';

export class DeviceFilterBuilder extends FilterBuilder<
  DeviceFilterInput,
  DeviceFilterBuilder
> {
  public allowedFilters: Array<keyof DeviceFilterInput> = [
    'name',
    'deviceType',
    'vendorId',
    'ideConfigId',
    'tag',
    'creationTimestamp',
    'groupId',
  ];

  constructor() {
    super();

    this.fieldMappings = {
      name: 'nameLower' as keyof DeviceFilterInput,
    };

    this.valueTransformers = {
      name: (value: string) => value.toLowerCase(),
    };
  }
}
